export const FETCH_FORECAST = 'forecast/FETCH_FORECAST';
export const FETCH_ORGANISATION_CLIENTS = 'forecast/FETCH_ORGANISATION_CLIENTS';
export const FETCH_FORECAST_AGGREGATE_DETAILS =
  'forecast/FETCH_FORECAST_AGGREGATE_DETAILS';
